<template>
    <div class="row mb-4">
        <div class="col-12 p-0">
            <b-tabs class="tab-container">
                <b-tab title="Entities" v-if="canAccessEntityManagementList" @click="tabChange('Entity Management')">
                    <entity-management :activeTab="activeTab"></entity-management>
                </b-tab>
                <b-tab title="Media Types" v-if="canAccessMediaTypeManagement" @click="tabChange('Media Types')">
                    <media-type :activeTab="activeTab"></media-type>
                </b-tab>
                <b-tab title="Supplier Mapping" v-if="canAccessSupplierMappingManagement" @click="tabChange('Supplier Mapping')">
                    <supplier-mapping :activeTab="activeTab"></supplier-mapping>
                </b-tab>
                <b-tab title="Maintenance" v-if="canAccessMaintenanceManagement" @click="tabChange('Maintenance')">
                    <maintenance-admin :activeTab="activeTab"></maintenance-admin>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
<script>
export default {
    name: "AdminRequestTable",
    data() {
        return {
            activeTab: ''
        };
    },
    computed: {
        canAccessEntityManagementList() {
            return this.$store.getters.canAccessEntityManagementList;
        },
        canAccessMediaTypeManagement() {
            return this.$store.getters.canAccessMediaTypeManagement;
        },
        canAccessSupplierMappingManagement() {
            return this.$store.getters.canAccessSupplierMappingManagement;
        },
        canAccessMaintenanceManagement() {
            return this.$store.getters.canAccessMaintenanceManagement;
        },
    },
    methods: {
        tabChange(tab) {
            this.activeTab = tab;
        },
    },
};
</script>
<style scoped>
    .tab-container {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
</style>